import MyReservations from './MyReservations'

export default MyReservations
